import {Component, OnInit, Input, Output, EventEmitter, SimpleChanges, Inject} from '@angular/core';
import {ArticleCommentService} from "@shared/components/article-comment/article-comment.service";
import {CommonsService} from "@core/service/commons.service";
import {environment} from "@env/environment";
import {PersonService} from "../../../routes/jy-org/person/service/person.service";
import {DA_SERVICE_TOKEN, TokenService} from "@delon/auth";

@Component({
  selector: 'app-article-comment',
  templateUrl: './article-comment.component.html',
  styles: []
})
export class ArticleCommentComponent implements OnInit {
  @Input() visible;//弹框是否可见
  @Input() fkId;//关联id（文章id）
  @Input() fkType;//关联分类（文章：'ARTICLE'）
  @Output() private close = new EventEmitter();
  constructor(private articleCommentService:ArticleCommentService,private commonsService:CommonsService,private personService:PersonService,@Inject(DA_SERVICE_TOKEN) private tokenService: TokenService) { }

  public userInfo:any = {};
  ngOnInit() {
    if(this.tokenService.get().token){
      this.getCurrent();
    }
  }
  //获取当前登录人员信息
  getCurrent(){
    this.personService.getCurrent().subscribe((data) => {
      this.userInfo = data;
    });
  }
  //删除评论
  removeComment(item){




    this.commonsService.showConfirm('确认删除这条评论？',
      ()=>{
        this.articleCommentService.delete(item.id).subscribe((res) => {
          this.commonsService.showSuccessMessage('删除成功');
          this.getContentList();
        })
      },
      ()=>{

      }
    )

  }
  public page:number = 1;
  public count:number = 0;
  public commentList:any = [];
  public commentContent:string = '';
  public commitLoading:boolean = false;
  //关闭弹窗
  closeModal(){
    this.close.emit();
  }
//  获取数据
  getContentList(){
    let obj = {
      direction: "DESC",
      fromClientType: "pc",
      number: this.page - 1,
      property: "createdDate",
      size:10,
      rules:[
        {
          field:'fkId',
          values:[this.fkId],
          option:"IN"
        },{
          field:'fkType',
          values:[this.fkType],
          option:"IN"
        }
      ]
    };
    this.articleCommentService.getPage(obj).subscribe((data) => {
      this.count = data.totalElements;
      if(data.content){
        this.commentList = data.content;
      }else{
        this.commentList = [];
      }
    })
  }
  //提交评论
  commitComment(){
    if(!this.commentContent){
      this.commonsService.showWarningMessage('请填写评论内容');
      return;
    }
    let commentObj = {
      fkId:this.fkId,
      fkType:this.fkType,
      content:this.commentContent
    };
    this.commitLoading = true;
    this.articleCommentService.add(commentObj).subscribe((data) => {
      this.commonsService.showSuccessMessage('提交成功');
      this.commentContent = '';
      this.page = 1;
      this.getContentList();
      this.commitLoading = false;
    },()=>this.commitLoading = false)
  }
  ngOnChanges(changes: SimpleChanges){
    if(changes.visible && this.visible){
      this.page = 1;
      this.commentContent = '';
      this.count = 0;
      this.commentList = [];
      this.getContentList();
    }
  }
}
